<div>
  <div
    *ngFor="let item of arrayOne(numberOfPages); let i = index"
    [class.page-break-after]="i !== numberOfPages - 1"
  >
    <ng-container
      *ngTemplateOutlet="printPage; context: { $implicit: { pageIndex: i } }"
    ></ng-container>
  </div>
</div>

<ng-template #printPage let-data>
  <div class="printing-page">
    <table cellPadding="0" cellSpacing="0" class="printTable">
      <thead>
        <tr>
          <th
            *ngFor="let column of tableColumns; let i = index"
            [ngClass]="{
              firstColumns: i > 1 && i <= 3,
              columnLocation: i === 0,
              columnCycle: i === 1,
              rotate: i > 3,
            }"
          >
            <div>
              <span>{{ column.label }}</span>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of tablePagesData[data.pageIndex]">
          <td *ngFor="let column of tableColumns" [ngClass]="{ right: column.type === 'number' }">
            {{ formatValue(row, column) }}
          </td>
        </tr>
        <tr class="customFooter" *ngIf="data.pageIndex === numberOfPages - 1">
          <td *ngFor="let column of tableColumns" [ngClass]="{ right: column.type === 'number' }">
            {{ getTotalValue(column.id, 0) }}
          </td>
        </tr>
        <ng-container *ngFor="let benchmarkIndex of getNumberOfBenchmarksToShow()">
          <tr class="customFooter" *ngIf="data.pageIndex === numberOfPages - 1">
            <td *ngFor="let column of tableColumns" [ngClass]="{ right: column.type === 'number' }">
              {{ getTotalValue(column.id, benchmarkIndex) }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</ng-template>
